package one.primehealth.analytics.compose

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import one.primehealth.analytics.AppAnalytics
import org.koin.compose.koinInject

@Composable
fun AppEventEffect(key: Any? = Unit, block: AppAnalytics.() -> Unit) {
    val appAnalytics = koinInject<AppAnalytics>()
    LaunchedEffect(key) {
        appAnalytics.block()
    }
}